import React from "react";
import { motion } from "framer-motion";

const ScaleBar = ({
  label = "",
  customTitle = null,
  value = 0,
  min = 1,
  max = 10,
  leftLabel = "Low",
  rightLabel = "High",
  palette = {},
  showValue = false,
  className = "",
}) => {
  // Use customTitle if provided, otherwise use label
  // If customTitle is empty string, don't show title (hidden)
  const displayLabel = customTitle !== null ? (customTitle === "" ? null : customTitle) : label;
  // Color logic (same as DBCS)
  const getBarBackground = (val) => {
    if (val >= max * 0.8) {
      return "linear-gradient(90deg, var(--primary-color) 0%, #4ade80 100%)";
    }
    if (val <= max * 0.4) {
      return "linear-gradient(90deg, #3b82f6 0%, var(--primary-color) 100%)";
    }
    return "linear-gradient(90deg, var(--primary-color) 0%, var(--accent-color) 100%)";
  };

  // Significance class for value
  const getSignificanceClass = (val) => {
    if (val >= max * 0.8) return "text-green-400 font-bold";
    if (val <= max * 0.4) return "text-blue-400 font-bold";
    return "";
  };

  return (
    <div className={`w-full ${className}`}>
      {displayLabel && (
        <div className="flex justify-between mb-1">
          <span className="font-medium text-white/90">{displayLabel}</span>
          {showValue && (
            <span className={`text-sm ${getSignificanceClass(value)}`}>
              {value}/{max}
            </span>
          )}
        </div>
      )}
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs text-white/60">{leftLabel}</span>
        <span className="text-xs text-white/60">{rightLabel}</span>
      </div>
      <div className="h-2 rounded-full overflow-hidden bg-black/20">
        <motion.div
          className="h-full rounded-full"
          initial={{ width: 0 }}
          animate={{ 
            // Use 0 as visual min so value of 1 shows as 10% (visible)
            // but values still map correctly: 1=10%, 5=50%, 10=100%
            width: `${((value - 0) / (max - 0)) * 100}%` 
          }}
          transition={{ duration: 0.5 }}
          style={{ background: getBarBackground(value) }}
        />
      </div>
    </div>
  );
};

export default ScaleBar;
